import React from "react";

export function StatCard({ label, value, sub, accent = "default", testId }) {
  const accentRing = {
    default: "border-slate-200",
    emerald: "border-l-2 border-l-emerald-500 border-slate-200",
    amber: "border-l-2 border-l-amber-500 border-slate-200",
    red: "border-l-2 border-l-red-500 border-slate-200",
    slate: "border-l-2 border-l-slate-900 border-slate-200",
  }[accent];

  return (
    <div data-testid={testId} className={`bg-white border ${accentRing} rounded-md p-5 flex flex-col gap-2`}>
      <div className="text-xs font-semibold text-slate-500 uppercase tracking-widest">{label}</div>
      <div className="font-mono text-2xl tabular-nums text-slate-900 break-all">{value}</div>
      {sub && <div className="text-xs text-slate-500">{sub}</div>}
    </div>
  );
}
